<template>
   <div class="home"  v-if="username" >
   <fullscreen :fullscreen.sync="fullscreen" ref="fullscreen" background="white"  >
      <Navigation :username='username' :studiocaller='studiocaller'   :canvas='canvas' ></Navigation>
<!--        <span v-touch:swipe="swipeHandler">Swipe Here</span> -->
<!--         <div class="wrapper"   v-touch:swipe="swipeHandler" >
            <div class="swipe">Swipe me</div>
         </div>-->
         <div id="container" >
<!--             <div class=" "> -->
                  <div class="fill active_contacts">
                     <div class="card ">
                        <div class="card-body ">
                         <h3>Call</h3>
                           <div class="input-group  d-flex justify-content-end">
                              <input class="form-control form-control-sm  w-75" ref="search" v-model="search" type="text" placeholder="Search..." aria-label="Search">
                           </div> 
                           <p v-if="errorText" class="text-danger">
                              {{errorText}}
                           </p>
                           <Contacts @call:incoming="focus_incoming_call" :wss="wss" ref="Contacts"  :names="get_onpeer" :mic="mic" :ctx="ctx" :peerUpdate="peerUpdate" :studiocaller="app" :search="search" :isMobile="isMobile" :parentRefs="$refs"  :p_date="date"/>
                        </div>
                     </div>
                  </div>
         </div>
         <p class="update_state" > {{this.peerUpdate}} </p> 
         <div class="debug_state" ref="debug_state">
            <br> 
         </div>
         <!-- <button @click="Check1">
            check124
         </button> -->
   </fullscreen>
   </div>

</template>

<script>

import Navigation from '../components/Navigation'
import Contacts from '../components/Contacts.vue'
import NoSleep from 'nosleep.js'
import json_errorText from './../assets/JSON/errorText.json';

var noSleep = new NoSleep();

export default {
   name: "home",
   props: {
      wss: Object,
      username: String,
      studiocaller: Object,
      isMobile: Boolean,
      mic: GainNode,
      ctx: AudioContext,
      date: {}
   },
   data: function () {
      return  {
         search: '',
         get_onpeer : Object,
         sec: 0,
         canvas: this.studiocaller,
         app: this.studiocaller,
         peerUpdate: Boolean,
         peers : Object,
         active_call : false,
         errorText: '',
         p_date: Object, 
         wss_id : this.studiocaller.wss.id,
      }
   },
   components: {
      Navigation,
      Contacts,
   },
   beforeMount() {
      this.p_date = this.date;
      this.wss.onpeer = this._onpeer.bind(this);
      this._onpeer();
      
      this.wss.onalert = (t) => {
         t  = t.replace(/ *\([^)]*\) */g, " ");
         t  = t.replace("+ act  +","");
         
         var replaced_key  = '' ; 
         this.errorText = '';
         
         for (var  key in json_errorText) {
               var  value = json_errorText[key];
               replaced_key  = key.replace("+ act  +","");
               replaced_key = "wsSock: "+ replaced_key ;
               if(value=="The connection to the server has been lost") {
                  this.wss.send({cmd:'log', data: this.p_date+  ' user: ' +this.wss_id+' Document reload in Home Component: ' + value});
                  document.location.reload(true);
               } else if(replaced_key  == t ) {
                  this.errorText = value;
               }
         }
         console.log('wss: ' + t);
      }
   },
   mounted:function() {
      this.checkName();  
      if(this.studiocaller) {
         this.get_onpeer = this.studiocaller.get_onpeer();
      } else {
         console.log('Studio Caller object not mounted');
      }
      noSleep.enable();
      if(this.isMobile) {
         this.full_screen();
      }
   },
   methods: {
      checkName() {
         if(!this.username) {
            this.$router.go(-1);
         }
      },
      focus_incoming_call() {
         this.$refs.search.scrollIntoView();
      },
      full_screen() {
        this.$refs['fullscreen'].toggle();
      },
      _onpeer() {
         Object.keys(this.wss.peers).forEach((id,_) => {
            var p = this.wss.peers[id];
            console.log(' _onpeer event in vue js ');
            if(p.updated) {
               if(this.peerUpdate) {
                  this.peerUpdate = false ; 
               } else {
                  this.peerUpdate = true ;
               }
               if(p.deleted) {
                  delete this.wss.peers[id];
               }
               p.updated = false; 
            }
            this.errorText = '' ;
         });
      },
   },
  beforeDestroy () {
   // document.removeEventListener("backbutton", this.BackFunction);
  },
   watch: {
      '$route' (to, from) {
         console.log('to' + to);
         console.log('from ' + from );
      },
   },
};
</script>

<style scoped>
   .home {
      height: 100%;
      flex-direction: column;
   }
   .row {
      margin-left: 0px;
      margin-right: 0px;
      height:100%;
   }
   .card-title {
      text-decoration: underline;
   }
   .input-group {
      margin-bottom: 10px;
   }
   .search_image {
      width:30px;
      height:30px;
   }
   #container {
      height: 80%;
   }
   .active_contacts .card {
      margin-bottom: 20px;
   }
   .fill {
      width:90%; /*set to 45 FIXME */ 
      display: inline-block;
   }
   .update_state {
      display: None;
   }
   @media (max-width: 900px) {
      .fill {
         display: contents;
/*         margin: auto ;
         margin-bottom: 10px ;
         display: contents;*/
      }
      .active_contacts{
/*          width: 100%; */
/*         margin: auto ;
         margin-bottom: 10px ;
         display: contents;*/
      }
   }
   .swipe {
      width: 100px;
      height: 30px;
      margin-top: auto;
      margin-bottom: auto;
      background-color: grey;
      color: white;
      font-family: Arial;
      text-align: center;
      line-height: 30px;
   }
   .test {
      position: absolute; 
      top: 0; 
      left: 0; 
      height: 100%; 
      width: 100%;
      background: #00800030;
   }
   .debug_state{
      float: left;
      margin: 20px;
   }

</style>
